export const MATRIX_ATTENDANCE_CORRECTION_TYPE = {
  TIME_ADJUSTMENT: 'time_adjustment',
  LEAVE: 'leave',
} as const;

export type MatrixAttendanceCorrectionType =
  (typeof MATRIX_ATTENDANCE_CORRECTION_TYPE)[keyof typeof MATRIX_ATTENDANCE_CORRECTION_TYPE];
